import axios from "axios";
import { ENDPOINTS } from "./ENDPOINT.js";

export const BooknLogService = {

   
    createBooking: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.BOOKROOM, data);
            return response.data;
        } catch (error) {
            console.error("Error creating booking:", error);
            throw error; 
        }
    },
    editBooking: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.BOOKROOM}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error editing booking:", error);
            throw error; 
        }
    },
    deleteBooking: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.BOOKROOM}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting booking:", error);
            throw error; 
        }
    },

    getRoomOccData: async (id, status) => {
        try {
            const response = await axios.get(`${ENDPOINTS.BOOKROOM}?id=${id}&status=${status}`);
            
            return response.data;
        } catch (error) {
            console.error("Error fetching logs:", error);
            throw error; 
        }
    },
    getAllLogs: async () => {
        try {
            const response = await axios.get(ENDPOINTS.LOGS);
            return response.data;
        } catch (error) {
            console.error("Error fetching logs:", error);
            throw error; 
        }
    },
    createLog: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.LOGS, data);
            return response.data;
        } catch (error) {
            console.error("Error creating log:", error);
            throw error; 
        }
    },
    editLog: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.LOGS}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error editing log:", error);
            throw error; 
        }
    },
    deleteLog: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.LOGS}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting log:", error);
            throw error; 
        }
    },
    deleteDocumentImage: async (name) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.DOC_DELETE}/${name}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting document image:", error);
            throw error; 
        }
    },

    checkOut: async (payload) => {
        try {
            const response = await axios.patch(`${ENDPOINTS.CHECKOUT}`, payload);
            return response.data;
        } catch (error) {
            console.error("Error during checkout:", error);
            throw error; 
        }
    },

    getRoomLog: async (room_id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.ROOM_LOG}?room_id=${room_id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error;
        }
    },
}